import { Random } from './Utility/Random';
import * as Sentry from '@sentry/browser';
import { IGameState } from './State/Game/IGameState';

export type ReportTags = Record<string, string | number | boolean>;

export type Categorizer = (
    error: unknown
) =>
    | undefined
    | {
          fingerprint: string;
          tags?: ReportTags;
      };

export const reportedOnce = Object.create(null);
let sentryEnabled = false;

export function setReportEnabledTo(enabled: boolean) {
    sentryEnabled = enabled;
}

export const SENTRY_EXTRA_STATE_DATA_KEY: string = 'redux-state';

export function report(
    message: string,
    extra: {
        error?: unknown;
        sampleRate?: number;
        once?: boolean;
        tags?: ReportTags;
        fingerprint?: string;
        categorizers?: ReadonlyArray<Categorizer>;
        state?: IGameState;
        data?: Record<string, unknown>;
    } = {}
) {
}

function convertToString(value: unknown): string {
    if (typeof value == 'string') {
        return value;
    } else {
        return value?.toString?.() ?? '<<n/a>>';
    }
}

export function convertError(error: unknown, optContext?: string): Error {
    if (error instanceof Error) return error;
    const context = optContext ? `${optContext} | ` : '';
    if (!error)
        return new Error(`${context}Falsy error: typeof = ${typeof error}`);
    const { code, message } = error as any;
    let keys = '<n/a>';
    try {
        keys = Object.keys(error as any).join(', ');
    } catch (error) {
        // no action
    }
    return new Error(
        `${context}Error Code ${code}; message = "${message}"; keys = ${keys}`
    );
}

export function assertTypeEquals<T>(
    debugName: string,
    varA: T,
    varB: T,
    expectedType?: string
) {
    const typeA = typeof varA;
    const typeB = typeof varB;
    if (typeA !== typeB || (expectedType && typeA !== expectedType)) {
        report(`Unexpected types for ${debugName}`, {
            once: true,
            tags: { typeA, typeB, expectedType },
        });
    }
}
